import { Box, Container, Grid, Heading, Text } from "@chakra-ui/react";
import PerspectiveBg from "../img/perspective-bg.png";
import React from "react";
import PerspectiveBox from "./PerspectiveBox";
import BlogImgOne from "../img/understanding.png";
import BlogImgTwo from "../img/mob.png";
import BlogImgThree from "../img/healthcare.png";
import BlogImgFour from "../img/Benefits.png";

const Perspective = ({ bg = PerspectiveBg }) => {
  const BlogData = [
    {
      id: 0,
      img: BlogImgOne,
      title: "Understanding the Leasing Process: What to expect when leasing a medical office space for your practice",
      link: "/understanding-the-leasing-process",
    },
    {
      id: 1,
      img: BlogImgTwo,
      title: "What is an MOB (Medical Office Building) and Why It Matters in Healthcare",
      link: "/what-is-mob",
    },
    {
      id: 2,
      img: BlogImgThree,
      title: "Healthcare Real Estate Leasing Terms Simplified",
      link: "/healthcare-real-estate-terms-simplified",
    },
    {
      id: 3,
      img: BlogImgFour,
      title: "Benefits of Leasing vs. Owning Medical Office Buildings",
      link: "/benefits-of-leasing",
    },
  ];
  return (
    <Box py={16} bgImage={bg} bgRepeat={"no-repeat"} bgSize={"cover"}>
      <Container maxW={{ md: "90%", base: "100%" }}>
        <Box textAlign={"center"}>
          <Text fontSize={{ md: "2xl", base: "lg" }} color={"BrightTurquoise"}>
            Our Perspective
          </Text>
          <Heading
            fontSize={{ md: "5xl", base: "45px" }}
            color={bg ? "white" : "DarkBlue"}
          >
            Leading the Way
          </Heading>
        </Box>
      </Container>
      <Container maxW={{ md: "90%", base: "100%" }} px={{ md: 4, base: 0 }}>
        <Grid
          mt={12}
          gridTemplateColumns={{ md: "repeat(2, 1fr)", sm: "repeat(1, 1fr)" }}
          gap={{ md: 12, base: 2 }}
          alignItems={"center"}
        >
          {BlogData?.map((i, j) => {
            return (
              <PerspectiveBox
                key={j}
                link={i?.link}
                title={i?.title}
                blogImg={i?.img}
              />
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default Perspective;
